import { amountToDisplayValue, Flex, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext, useWatch } from '../../../../../../../../hooks'
import { useVatDeclaration } from '../../../../../../context/vatDeclarationContext'
import { VatDeclarationsDefinePeriodPayoutModalFormSchema } from '../../../../utils/formData'

export const DefinePayoutDetails = (): ReactElement => {
  const { t } = useTranslation()
  const { totalAmount } = useVatDeclaration()
  const { control } = useFormContext<VatDeclarationsDefinePeriodPayoutModalFormSchema>()
  const definedPayoutAmount = useWatch({ control, name: 'amount' })

  const amountToMoveToNewPeriod = useMemo(() => totalAmount - definedPayoutAmount, [definedPayoutAmount, totalAmount])

  return (
    <Flex justifyContent="space-between">
      <Flex.Item alignSelf="flex-end">
        <Text variant="bodyLG">{t('vat_declarations.define_payout_modal.details.label')}</Text>
      </Flex.Item>
      <Flex flexDirection="column">
        <Text alignment="right" variant="bodySM" colorVariant="secondary">
          {t('vat_declarations.define_payout_modal.details.amount')}
        </Text>
        <Text alignment="right" variant="h4">
          {amountToDisplayValue(amountToMoveToNewPeriod)}
        </Text>
      </Flex>
    </Flex>
  )
}
